// Action Types
export const CREATE_INVENTORY = 'CREATE_INVENTORY';
export const DELETE_INVENTORY = 'DELETE_INVENTORY';
export const GET_ALL_INVENTORY = 'GET_ALL_INVENTORY';
export const GET_ID_INVENTORY = 'GET_ID_INVENTORY';
export const SEARCH_INVENTORY = 'SEARCH_INVENTORY';
export const UPDATE_INVENTORY = 'UPDATE_INVENTORY';
export const ADJUST_STOCK = 'ADJUST_STOCK';
export const TRANSFER_INVENTORY = 'TRANSFER_INVENTORY';
export const GET_INVENTORY_TRANSFER_HISTORY = 'GET_INVENTORY_TRANSFER_HISTORY';
export const UPDATE_INVENTORY_LOCATION = 'UPDATE_INVENTORY_LOCATION';
export const BULK_CREATE_INVENTORY = 'BULK_CREATE_INVENTORY';
export const BULK_UPDATE_INVENTORY = 'BULK_UPDATE_INVENTORY';
export const BULK_DELETE_INVENTORY = 'BULK_DELETE_INVENTORY';
export const GET_INVENTORY_REPORT = 'GET_INVENTORY_REPORT';
export const GET_LOW_STOCK_ITEMS = 'GET_LOW_STOCK_ITEMS';
export const GET_INVENTORY_VALUATION = 'GET_INVENTORY_VALUATION';

// Inventory Statuses
export const INVENTORY_STATUSES = {
    IN_STOCK: 'In Stock',
    LOW_STOCK: 'Low Stock',
    OUT_OF_STOCK: 'Out of Stock',
    OVERSTOCK: 'Overstock',
    PENDING: 'Pending',
    RESERVED: 'Reserved'
};

// Stock Adjustment Types
export const STOCK_ADJUSTMENT_TYPES = {
    ADD: 'add',
    REDUCE: 'reduce',
    SET: 'set',
    RETURN: 'return',
    DAMAGED: 'damaged',
    EXPIRED: 'expired'
};

// Inventory Field Labels
export const INVENTORY_LABELS = {
    SKU: 'SKU',
    NAME: 'Nama Produk',
    CATEGORY: 'Kategori',
    WAREHOUSE: 'Gudang',
    LOCATION: 'Lokasi',
    STOCK: 'Stok',
    MIN_STOCK: 'Min. Stok',
    MAX_STOCK: 'Max. Stok',
    UNIT_PRICE: 'Harga Satuan',
    TOTAL_VALUE: 'Nilai Total',
    STATUS: 'Status',
    LAST_RESTOCKED: 'Terakhir Restock'
};

// Pagination Defaults
export const INVENTORY_PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 10,
    MAX_LIMIT: 100
};
